import { render, staticRenderFns } from "./KLTNByDepartmentEchartBar.vue?vue&type=template&id=2b0db71b&"
import script from "./KLTNByDepartmentEchartBar.vue?vue&type=script&lang=js&"
export * from "./KLTNByDepartmentEchartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports